import axios from 'axios';
import apiClient from '../../../services/apiClient';

const API_BASE_URL = window.getApiUrl();

export const uploadCurriculumImage = (filename: string, image: Blob) => {
  return apiClient
    .get<{ url: string }>(`${API_BASE_URL}/curriculum-storage/images/upload-url?key=${filename}`)
    .then(response => {
      const requestData = {
        headers: { 'Content-Type': image.type !== '' ? image.type : 'application/octet-stream' },
        onUploadProgress: () => {},
      };

      return axios.put(response.data.url, image, requestData);
    });
};
